import type { ClientService } from './session';

/** The service every portal area shares, whichever service is active. */
export const CORE_SERVICE = 'core';

/**
 * Whether the portal is narrowed to one of the client's services for pages of
 * `service`: only a service its selector switches between. One no entry is —
 * the core, or the account-wide `integrations` (API keys, webhooks) — belongs
 * to the whole account, so working in any service never hides it.
 *
 * Both kits' `Guarded` ask this, so a page cannot be reachable in one app and
 * bounced in another.
 */
export function narrowsTo(services: readonly ClientService[], service: string): boolean {
  return service !== CORE_SERVICE && services.some((entry) => entry.service === service);
}
